import React, { FC } from 'react';
import { default as MuiSelect } from '@material-ui/core/Select';
import { default as MuiMenuItem } from '@material-ui/core/MenuItem';
import { SelectProps } from './types';
import useStyles, { itemStyle } from './style';
import { cx } from '../customEmotion';

const Select: FC<SelectProps> = (props) => {
  const {
    options,
    value,
    onChange,
    variant = 'outlined',
    multiple = false,
    onOpen,
    onClose,
    height,
    backgroundColor,
    isVarItem = false,
    ...restProps
  } = props;

  const classes = useStyles(props);
  const itemClasses = itemStyle(props);

  return (
    <MuiSelect
      className={classes.root}
      value={value}
      onChange={onChange}
      variant={variant}
      multiple={multiple}
      onOpen={onOpen}
      onClose={onClose}
      displayEmpty
      fullWidth
      {...restProps}
    >
      {options.map(option => (
        <MuiMenuItem
          className={itemClasses.container}
          value={option.value}
          key={option.value}
        >
          {isVarItem ? <div
            className={cx(itemClasses.root, itemClasses.var)}
          >
            {option.children}
          </div> : option.children}
        </MuiMenuItem>
      ))}
    </MuiSelect>
  );
};

export default Select;
